import React, { Component } from 'react';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';

import moment from 'moment'
import 'moment/locale/es'  
import { Button } from '@material-ui/core';
// Component styles
import styles from '../styles';
moment.locale('es')

class Variable extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  
  render() {
    const { classes  } = this.props;
    return (
      <Grid
      container
      spacing={3}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        xl={12}
        className={classes.alignLeft}
      >
        <Typography className={classes.textGrey} variant="h4">VARIABLES TEMPLATE </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        xl={12}
        className={classes.alignLeft}
        style={{padding:"4px"}}
        
      >
        <Typography className={[classes.textGrey, classes.size12]} variant="h6">El siguiente listado de variables obtenidas </Typography>
        <Typography className={[classes.textGrey, classes.size12]} variant="h6">desde el sistema de alertas Atentus. Se</Typography>
        <Typography className={[classes.textGrey, classes.size12]} variant="h6">encuentra disponibles para reemplazo</Typography>
        <Typography className={[classes.textGrey, classes.size12]} variant="h6">en el template.</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        xl={12}
        className={classes.alignLeft}
        style={{padding:"0px"}}
      >
        <Typography className={classes.textGrey} variant="h6">* Servicio: $[servicio] </Typography>
        <Typography className={classes.textGrey} variant="h6">* Objetivo asociado: $[objetivo] </Typography>
        <Typography className={classes.textGrey} variant="h6">* Fecha alerta: $[fecha] </Typography>
        <Typography className={classes.textGrey} variant="h6">* Hora: $[hora] </Typography>
        <Typography className={classes.textGrey} variant="h6">* Motivo de alerta: $[motivo] </Typography>
        <Typography className={classes.textGrey} variant="h6">* Detalle de error: $[cuerpo_alerta] </Typography>
        <Typography className={classes.textGrey} variant="h6">* TipoAlerta: $[tipo_alerta] (global, uptime) </Typography>
        
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        xl={12}
        className={classes.alignLeft}
      >
        <Typography variant="h6" className={classes.textGrey10} >Nota: Para ingresar salto(s) de línea(s) ocupar el carácter especial “\n”</Typography>
      </Grid>
    </Grid>
             
    )
  }
}

export default withStyles(styles)(Variable);
